module.exports = "#define GLSLIFY 1\n  gl_FragColor = linearToOutputTexel( gl_FragColor );\n"


//////////////////
// WEBPACK FOOTER
// ./src/vendor/three/renderers/shaders/ShaderChunk/encodings_fragment.glsl
// module id = 230
// module chunks = 0